import { Grid } from '@methanesat/ui-components';
import { DrawerCardContentProps } from '../../../../types';
import { DrawerCardContentHeader } from '../Headers/DrawerCardContentHeader';

export const DrawerCardContent = ({ titleLabel, titleValue, locationSubtitle, Content }: DrawerCardContentProps) => {
    return (
        <Grid container flexDirection="column">
            <Grid size="grow">
                <DrawerCardContentHeader
                    titleLabel={titleLabel}
                    titleValue={titleValue}
                    locationSubtitle={locationSubtitle}
                />
            </Grid>
            <Grid size="grow" sx={{ marginTop: 2 }}>
                {Content}
            </Grid>
        </Grid>
    );
};
